module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('homepage', [_c('div', {
    staticClass: "m-block"
  }, [_c('h2', [_vm._v(_vm._s(_vm.news.title))]), _vm._v(" "), _c('div', {
    staticClass: "blog-single-head-date"
  }, [_c('p'), _c('div', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" Publicado em " + _vm._s(_vm.formatDate(_vm.news.dateTime)))]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.news.content)
    }
  })]), _vm._v(" "), _vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cb3910a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/portal/ReadNews.vue
// module id = 684
// module chunks = 1